
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getEmailTemplatesList = (sessionKey) =>
{
    return new Promise((resolve, reject) =>
    {
        BaseService
            .requestHeaders(sessionKey)
            .then((headers) =>
            {
                resolve( axios.get(`${Environment.apiUrl}/EmailTemplates/List`, headers) )
            })
            .catch((error) =>
            {
                reject(error)
            })
    })
}

const EmailTemplatesService =
{
    getEmailTemplatesList
}

export default EmailTemplatesService
